import React, { Component } from 'react';
import HashService from './HashService';
import Panic from './Panic';

const Default404 = (props) => <div>NOT FOUND</div>;

class Reout {
	constructor() {
		const reout = this;

		this.nav_listeners = [];
		this.n = 0;

		const add_nav_listener = (fn) => {
			this.nav_listeners.push(fn);
		};

		const remove_nav_listener = (fn) => {
			this.nav_listeners = this.nav_listeners.filter(x => x !== fn);
		};

		this.Component = class extends Component {
			constructor(props) {
				super(props);
				this.state = {seq: 0};
				this.navListener = (ev) => {
					this.setState((state) => ({seq: state.seq+1}));
					if (ev) ev.preventDefault();
				};
			}

			componentDidMount() {
				window.addEventListener("popstate", this.navListener);
				add_nav_listener(this.navListener);
			}

			componentWillUnmount() {
				remove_nav_listener(this.navListener);
				window.removeEventListener("popstate", this.navListener);
			}

			render() {
				return reout.navigate();
			}
		}

		const BlessLink = (props) => {
			const child = React.Children.only(props.children);

			/* XXX TODO; say props.onClick is set, what do we do?
			 * it could happen if an <a onClick="..."/> was
			 * automatically converted to an <A onClick="..."/> ..
			 * but isn't that typically a mistake? I mean, an <a>
			 * onClick handler will _typically_ call
			 * preventDefault(), because we're already overriding
			 * default behavior? possible actions:
			 *  - throw an exception (or maybe a warning); "You
			 *    wrapped something that does not need wrapping,
			 *    please fix your shit"?
			 *  - pass a fake event object to the onClick handler,
			 *    containing a preventDefault() that will prevent
			 *    our go() stuff?
			 *  - pass child as-is (no wrapping) if it contains an
			 *    onClick?
			 */

			var child_props = {...child.props};

			if (child_props.href) {
				child_props.href = this.mk_href(child_props.href);
			}

			if (child_props.onClick && !props.allow_on_click) {
				// XXX lets see how this works for a solution
				throw new Error("<BlessLink> used around <" + child.type + "> but an onClick handler was specified; you're probably doing it wrong");
			}

			child_props.onClick = (e) => {
				this.raw_go(child_props.href);
				e.preventDefault();
			};
			return React.cloneElement(child, child_props);
		};

		this.BlessLink = BlessLink;

		this.A = (props) => {
			return <BlessLink><a {...props}>{props.children}</a></BlessLink>
		};
	}

	get_404_handler() {
		return Default404;
	}

	get_language_prefixes() {
		return []; // override
	}

	get_language_prefix_set() {
		var set = {};
		for (const lang of this.get_language_prefixes()) set[lang] = true;
		return set;
	}

	path_array_get_language_prefix(path_array) {
		const language_prefix_set = this.get_language_prefix_set();
		if (language_prefix_set && path_array.length >= 1 && language_prefix_set[path_array[0]]) {
			return path_array[0];
		} else {
			return false;
		}
	}

	path_array_has_language_prefix(path_array) {
		return !!this.path_array_get_language_prefix(path_array);
	}

	preserve_language_prefix(href) {
		var xs = href.split("/").filter(x=>x);
		if (xs.length >= 1 && this.get_language_prefix_set()[xs[0]]) {
			xs = xs.slice(1);
		}

		const prefix = this.path_array_get_language_prefix(this.get_path_array());
		if (prefix) {
			xs = [prefix, ...xs];
		}

		if (xs.length === 0) xs = [''];

		return ['', ...xs].join("/");
	}

	shallow_copy(obj) {
		var copy = {};
		for (var k in obj) copy[k] = obj[k];
		return copy;
	}

	path_to_array(path) {
		return path.split("/").filter(x=>x);
	}

	expand(pathname) {
		const [ path, query ] = pathname.split("?");
		var args = {};
		if (query !== undefined) {
			for (const q of query.split("&")) {
				const [k,v] = q.split("=");
				args[k] = decodeURIComponent(v);
			}
		}
		return [this.path_to_array(path), args];
	}

	mk_href(pattern, args) {
		args = this.shallow_copy(args || {});

		var [path_array, query] = this.expand(pattern);

		var path = "";
		var kset = {};
		for (const e of path_array) {
			if (e[0] === ":") {
				const k = e.slice(1);
				const v = args[k];
				if (v === undefined) Panic(`missing path arg for ${e}`);
				path += "/" + encodeURIComponent(v);
				kset[k] = true;
			} else {
				path += `/${e}`;
			}
		}

		var sep = "?";
		for (const name in query) {
			const e = query[name];
			if (e[0] === ":") {
				const k = e.slice(1);
				const v = args[k];
				if (v === undefined) Panic(`missing query arg for ${e}`);
				path += `${sep}${k}=` + encodeURIComponent(v);
				kset[k] = true;
			} else {
				path += `${sep}${name}=${e}`;
			}
			sep = "&";
		}

		for (var k in kset) delete args[k];
		const remaining_keys = Object.keys(args);
		if (remaining_keys.length > 0) Panic(`unused args: ${remaining_keys}`);

		/* TODO verify path against route (extract from navigate()?) */

		if (path === "") path = "/";

		return this.preserve_language_prefix(path);
	}

	href(pattern, args) {
		/* short-hand; convenient elsewhere (R.href(...)) but less
		 * convenient here, where there are many variables named href
		 * */
		return this.mk_href(pattern, args);
	}

	emit_nav_event() {
		for (const fn of this.nav_listeners) fn();
	}

	raw_go(href, history_fn) {
		if (!history_fn) history_fn = "pushState";
		window.history[history_fn]({}, '', href);
		this.emit_nav_event();
	}

	_nav(history_fn, pattern, args) {
		this.raw_go(this.mk_href(pattern, args), history_fn);
	}

	go(pattern, args) {
		this._nav("pushState", pattern, args);
	}

	replace(pattern, args) {
		this._nav("replaceState", pattern, args);
	}

	goto_url(url) {
		window.location.assign(url);
	}

	/* XXX this isn't optimal; the intent is to ensure that a page is
	 * refreshed even when you go() to the URL you're already on, however
	 * window.location.reload() actually does a reload like ctrl+R which is
	 * overkill; it would be better if all React components just re-mounted
	 * themselves, but it's not trivial to do */
	go_or_reload(pattern, args) {
		const href_before = window.location.href;
		this.go(pattern, args);
		const href_after = window.location.href;
		if (href_after === href_before) {
			window.location.reload();
		}
	}

	patch(patch) {
		const query = window.location.search.split("?");
		var args = [];
		if (query.length === 2) {
			const parts = query[1].split("&");
			for (const part of parts) {
				const name_value = part.split("=");
				const name = name_value[0];
				const value = patch[name] === undefined ? name_value[1] : encodeURIComponent(patch[name]);
				args.push([name, value]);
			}
		} else {
			for (const name in patch) args.push([name, encodeURIComponent(patch[name])]);
		}

		var href = window.location.pathname;
		var sep = "?";
		for (var i = 0; i < args.length; i++) {
			href += sep + args[i][0] + "=" + args[i][1];
			sep = "&";
		}

		return href;
	}

	get_path_array_and_args() {
		return this.expand(window.location.pathname + window.location.search);
	}

	get_path_array() {
		return this.get_path_array_and_args()[0];
	}

	get_args() {
		return this.get_path_array_and_args()[1];
	}

	get_arg(name) {
		return this.get_args()[name];
	}

	/* URL rewrite like /#/foo/bar -> /foo/bar; meant to catch remote URLs
	 * from back when we used window.location.hash for front-end routes */
	handle_legacy_hash_redirect() {
		if (window.location.hash.slice(0,2) === "#/") {
			const correct_url = ('/' + window.location.pathname + '/' + window.location.hash.slice(1)).replace(/\/+/g, '/');
			window.history.replaceState({}, '', correct_url);
		}
	}

	on_pageview(path, n) {
		// override me
	}

	navigate() {
		this.handle_legacy_hash_redirect();

		if (HashService.has_minor_change()) {
			window.location.reload();
			return;
		}

		this.on_pageview(window.location.pathname, this.n++);

		var path_array = this.get_path_array();

		/* strip potential language prefix */
		if (this.path_array_has_language_prefix(path_array)) {
			path_array = path_array.slice(1);
		}

		var routes = this.get_routes();
		var chain = [];
		window.scrollTo(0,0);
		var args = {};
		for (;;) {
			var best_match = undefined;
			var best_match_length = undefined;
			var best_match_args = {};
			var container;
			for (const key in routes) {
				const value = routes[key];

				if (key === "" || key[0] === "/") {
					var key_array = this.path_to_array(key);

					if (key_array.length > path_array.length) continue;

					var possible_args = {};
					var does_match = true;
					for (var i = 0; i < key_array.length; i++) {
						const e = key_array[i];
						if (e[0] === ":") {
							possible_args[e.slice(1)] = decodeURIComponent(path_array[i]);
						} else if (e !== path_array[i]) {
							does_match = false;
							break;
						}
					}

					if (!does_match) continue;

					if (key_array.length === best_match_length) {
						Panic(`multiple ambiguous routes for path=${path_array} key=${key}`);
					} else if (best_match === undefined || key_array.length > best_match_length) {
						best_match = value;
						best_match_length = key_array.length;
						best_match_args = possible_args;
					}
				} else if (key === "container") {
					if (typeof value !== "function") Panic(`invalid container value`);
					container = value;
				} else {
					Panic(`invalid route key ${key}`);
				}
			}

			const h404 = this.get_404_handler();

			if (best_match === undefined) {
				chain.push([h404, this.shallow_copy(args)]);
				break;
			} else {
				path_array = path_array.slice(best_match_length);

				if (container) chain.push([container, this.shallow_copy(args)]);

				for (var k in best_match_args) args[k] = best_match_args[k];

				if (typeof best_match === "function") {
					if (path_array.length > 0) {
						chain.push([h404, this.shallow_copy(args)]);
						break;
					} else {
						chain.push([best_match, this.shallow_copy(args)]);
						break;
					}
				} else {
					routes = best_match;
				}
			}
		}

		if (chain.length === 0) Panic("empty chain");

		var top = null;
		for (const [component, props] of chain.reverse()) {
			if (top) props.child = top;
			top = React.createElement(component, props);
		}
		return top;
	}

	get_current_language() {
		const path_array = this.get_path_array();
		return this.path_array_get_language_prefix(path_array) || this.get_default_language();
	}

	goto_language(lang) {
		const current_language = this.get_current_language();
		if (current_language === lang) return;
		const pathname = window.location.pathname;
		if (this.get_language_prefix_set()[lang]) {
			window.location.pathname = "/" + lang + pathname;
		} else if (this.get_default_language() === lang) {
			const strip_prefix = "/" + current_language;
			if (pathname.slice(0, strip_prefix.length) === strip_prefix) {
				window.location.pathname = pathname.slice(strip_prefix.length);
			}
		} else {
			throw new Error("invalid lang: " + lang);
		}
	}

	component() {
		const { Component } = this;
		return <Component/>
	}
}

export default Reout;



// WEBPACK FOOTER //
// ./src/Reout.js